import Sparkles from '@mp4s/sparkling_background.mp4';
import React from 'react';

import { VideoElement } from './SparklesAnimation.layoutProps';

const SparklesAnimation = () => (
  <VideoElement autoPlay loop muted>
    <source src={Sparkles} type="video/mp4" />
  </VideoElement>
);

export default SparklesAnimation;
